import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { ImportRepositoryBase } from '@skylab-shared/business';
export { ImportRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(ImportRepositoryBase)
export class ImportRepository {
    public constructor(
        http: Http
    ) { }
}
